export function LoadingState({ label = 'Loading…' }: { label?: string }): JSX.Element {
  return (
    <div className="loading-state" role="status" aria-live="polite">
      <span className="loading-state__spinner" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}
